import ChatFilesProvider from './ChatFiles.provider';

export default ChatFilesProvider;
